export const ONLINE_STATUS_CHANGED = 'ONLINE_STATUS_CHANGED';

export function onlineStatusChanged(data) {
  return {
    type: ONLINE_STATUS_CHANGED,
    payload: data,
  };
}
